export const REQUEST = 'Group/REQUEST';
export const SUCCESS = 'Group/SUCCESS';
export const ERROR = 'Group/ERROR';

export const ADDED = 'Group/ADDED';
export const SET = 'Group/SET';
export const USER_DELETED = 'Group/USER_DELETED';
export const USER_ADDED = 'Group/USER_ADDED';
export const INVITATION_REJECTED = 'Group/INVITATION_REJECTED';
export const USER_UPDATED = 'Group/USER_UPDATED';